import { Add } from "@mui/icons-material";
import ChatSettingsTooltip from "src/reusable/components/ChatSettingsTooltip";
import { IconButton } from "@mui/material";

const UploadFileButton = ({
  openFileDialog,
}: {
  openFileDialog: () => void;
}) => {
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    openFileDialog();
  };

  return (
    <ChatSettingsTooltip
      title="Upload files"
      placement="top"
      enterDelay={200}
      arrow
    >
      <IconButton
        size="small"
        onClick={handleClick}
        data-testid="aa-input-file-upload-btn"
        data-attr="assistant:btn:upload-file"
        sx={{
          padding: "4px",
        }}
      >
        <Add color="inherit" />
      </IconButton>
    </ChatSettingsTooltip>
  );
};

export default UploadFileButton;
